import * as minigameRuleset from './minigame.ruleset';
import { minigameSchema } from './minigame.schema';
import { minigameGetters } from './minigame.getters';
import { minigameActions } from './minigame.actions';
import { Inventory } from '../buruburu/inventory';
import { ReplicantModuleState } from '../utils';
import { Immutable } from '@play-co/replicant';
import { Care } from '../buruburu/care';
import { Tutorial } from '../buruburu/tutorial';

export type { MinigameType } from './minigame.ruleset';

export type Minigame = typeof Minigame;
// eslint-disable-next-line no-redeclare
export namespace Minigame {
  export const $DEPENDENCIES = { Inventory, Care, Tutorial };

  export const ruleset = minigameRuleset;
  export const schema = minigameSchema;
  export const getters = minigameGetters($DEPENDENCIES);
  export const actions = minigameActions(Minigame, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Minigame>;
  export type State = Immutable<MutableState>;
}
